import type { ThemeColors } from "../../UCIndependentChat/hooks/useTheme";
import type { PageThemeTokens } from "./types";

/** 将 V2 页面 Token 映射为 Chat 组件可用的 ThemeColors */
export function toChatThemeColors(tokens: PageThemeTokens): ThemeColors {
  const isDark = tokens.appearance === "dark";

  return {
    background: tokens.background,
    text: tokens.text,
    textSecondary: tokens.textSecondary,
    border: tokens.border,
    borderSecondary: tokens.border,
    hoverBg: tokens.hoverBg,
    hoverText: tokens.accent,
    senderBg: tokens.senderBg,
    senderBorder: tokens.senderBg,
    senderPlaceholder: tokens.chatInputPlaceholder,
    messageBg: tokens.messageBg,
    evaluationBg: isDark ? tokens.cardBg : "#f6ffed",
    evaluationBorder: isDark ? tokens.border : "#d9f7be",
    evaluationText: tokens.statusOnline,
    evaluationMeta: tokens.accent,
    evaluationFeedbackBg: isDark ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.8)",
    evaluationFeedbackBorder: tokens.border,
    evaluationFeedbackText: tokens.text,
    evaluationSkippedBg: tokens.cardBg,
    evaluationSkippedBorder: tokens.border,
    evaluationSkippedText: tokens.textSecondary,
    shadow: tokens.shadow,
    shadowStrong: tokens.shadow,
    removeButtonBg: isDark ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.45)",
    removeButtonBgHover: isDark ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.65)",
    imageLoadingBg: isDark ? "rgba(0,0,0,0.6)" : "rgba(255,255,255,0.8)",
    appearance: tokens.appearance,
  };
}
